import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export class RemoveIdentityProviderRequest extends Request<string, ISiteSAMLConfiguration> {
  constructor(idpConfigurationId: string) {
    super('removeIdentityProvider', idpConfigurationId);
  }
}
